export const Types = {
  GET_TASK_REQUEST: 'GET_TASK_REQUEST',
  SET_CURRENT_TASK: 'SET_CURRENT_TASK',
  GET_TASK_SUCCESS: 'GET_TASK_SUCCESS',
  GET_PENDINGJOBS_REQUEST: 'GET_PENDINGJOBS_REQUEST',
  GET_ACTIONREQUIRED_REQUEST: 'GET_ACTIONREQUIRED_REQUEST',
  GET_CLOSEDJOBS_REQUEST: 'GET_CLOSEDJOBS_REQUEST',
  GET_UNDATEDTASK_REQUEST: 'GET_UNDATEDTASK_REQUEST',
  SELECT_TASK: 'SELECT_TASK',
  RESET_SELECTED_TASK: 'RESET_SELECTED_TASK',
  SET_INVOICE_FILTER_KEY: 'SET_INVOICE_FILTER_KEY',
  REMOVE_INVOICE_TASK_LIST: 'REMOVE_INVOICE_TASK_LIST',
  SET_PAGE_SIZE: 'SET_PAGE_SIZE',
  SET_USER_INFO: 'SET_USER_INFO', // Burada olmamalı
  SET_WORKORDER_TO_CACHE: 'SET_WORKORDER_TO_CACHE',
};


export const getTasksRequest = () => ({
  type: Types.GET_TASK_REQUEST
});
export const getUndatedTasksRequest = () => ({
  type: Types.GET_UNDATEDTASK_REQUEST
});
export const getPendingJobsRequest = () => ({
  type: Types.GET_PENDINGJOBS_REQUEST
});
export const getActionRequiredRequest = () => ({
  type: Types.GET_ACTIONREQUIRED_REQUEST
});
export const getClosedJobsRequest = () => ({
  type: Types.GET_CLOSEDJOBS_REQUEST
});
export const setTask = (task) => ({
  type: Types.SET_CURRENT_TASK,
  payload: { task }
});
export const getTasksSuccess = (tasks) => (
  {
    type: Types.GET_TASK_SUCCESS,
    payload: { tasks }
  });

export const selectTask = (task) => ({
  type: Types.SELECT_TASK,
  payload: { task }
});

export const resetSelectedTask = (task) => ({
  type: Types.RESET_SELECTED_TASK,
  payload: { task }
});
// **
export const setUndatedTask = (undatedtask) => ({
  type: Types.SET_CURRENT_TASK,
  payload: { undatedtask }
});
export const getUndatedTasksSuccess = (undatedtask) => (
  {
    type: Types.GET_TASK_SUCCESS,
    payload: { undatedtask }
  });
export const setPendingJobs = (pendingjobs) => ({
  type: Types.SET_CURRENT_TASK,
  payload: { pendingjobs }
});
export const getPendingJobsSuccess = (pendingjobs) => (
  {
    type: Types.GET_TASK_SUCCESS,
    payload: { pendingjobs }
  });
export const setActionRequired = (actionRequired) => ({
  type: Types.SET_CURRENT_TASK,
  payload: { actionRequired }
});
export const getActionRequiredSuccess = (actionRequired) => (
  {
    type: Types.GET_TASK_SUCCESS,
    payload: { actionRequired }
  });
export const setClosedJobs = (closedJobs) => ({
  type: Types.SET_CURRENT_TASK,
  payload: { closedJobs }
});
export const getClosedJobsSuccess = (closedJobs) => (
  {
    type: Types.GET_TASK_SUCCESS,
    payload: { closedJobs }
  });
export const selectUndatedTask = (undatedtask) => ({
  type: Types.SELECT_TASK,
  payload: { undatedtask }
});
export const selectPendingJobs = (pendingjobs) => ({
  type: Types.SELECT_TASK,
  payload: { pendingjobs }
});
export const selectActionRequired = (actionRequired) => ({
  type: Types.SELECT_TASK,
  payload: { actionRequired }
});
export const selectClosedJobs = (closedJobs) => ({
  type: Types.SELECT_TASK,
  payload: { closedJobs }
});

export const resetUndatedSelectedTask = (undatedtask) => ({
  type: Types.RESET_SELECTED_TASK,
  payload: { undatedtask }
});
export const resetPendingSelectedJobs = (pendingjobs) => ({
  type: Types.RESET_SELECTED_TASK,
  payload: { pendingjobs }
});
export const resetActionRequiredSelected = (actionRequired) => ({
  type: Types.RESET_SELECTED_TASK,
  payload: { actionRequired }
});
export const resetClosedJobsSelected = (closedJobs) => ({
  type: Types.RESET_SELECTED_TASK,
  payload: { closedJobs }
});
// **
export const setInoviceFilterKey = (value) => ({
  type: Types.SET_INVOICE_FILTER_KEY,
  payload: { value }
});

export const removeInvoiceTaskList = (value) => ({
  type: Types.REMOVE_INVOICE_TASK_LIST,
  payload: { value }
});

export const setPageSize = (value) => ({
  type: Types.SET_PAGE_SIZE,
  payload: { value }
});

export const setUserInfo = (value) => ({
  type: Types.SET_USER_INFO,
  payload: { value }
});


export const setWorkOrderToCache = (value, receiptNo, technicianCode, appointmentDate) => ({
  type: Types.SET_WORKORDER_TO_CACHE,
  payload: { WorkOrderId: receiptNo, Payload: value, TechnicianCode: technicianCode, AppointmentDate: appointmentDate }
})
